import { applicationSteps } from "@quest-finance/quest-fe-shared/dist/application";
import { sprintf } from "sprintf-js";
import { Slug } from "../types/Navigation";

export const creditAssessment = "/ce/admin/%s/%s";
export const creditAssessmentRoot = sprintf(
  creditAssessment,
  ":assessmentId",
  ":section?"
);
export const asmAplQuote = sprintf(creditAssessment, "%s", Slug.QUOTE);
export const asmAplApplicantGuarantors = sprintf(
  creditAssessment,
  "%s",
  Slug.APPLICANT_GUARANTORS
);
export const asmAplRefStatements = sprintf(
  creditAssessment,
  "%s",
  Slug.REF_STATEMENTS
);
export const asmAplSecurity = sprintf(creditAssessment, "%s", Slug.SECURITY);
export const asmAplNotesContract = sprintf(
  creditAssessment,
  "%s",
  Slug.NOTES_CONTRACTS
);
export const asmAplDecision = sprintf(creditAssessment, "%s", Slug.DECISION);
export const asmAplSettlement = sprintf(
  creditAssessment,
  "%s",
  Slug.SETTLEMENT
);
export const asmAplAuditLogs = sprintf(creditAssessment, "%s", Slug.AUDIT_LOG);

export const legacyPageMapping: Record<
  applicationSteps.APPLICATION_STEPS,
  string
> = {
  quotes: asmAplQuote,
  applicant: asmAplApplicantGuarantors,
  guarantors: asmAplApplicantGuarantors,
  security: asmAplSecurity,
  notes: asmAplNotesContract,
  contracts: asmAplNotesContract,
  admin: asmAplQuote,
};
